<template>
    <slot v-if="condition"/>
</template>

<script setup>
const props = defineProps({
    path: String
})
const route = useRoute()

const condition = computed(() => {
    if(props.path){
        return route.path.includes(props.path)
    }
})
</script>